var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defineComponent, h } from 'vue';
import classNames from '../_util/classNames';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import DefaultEmptyImg from './empty';
import SimpleEmptyImg from './simple';
import { filterEmpty } from '../_util/props-util';
import { anyType, objectType, withInstall } from '../_util/type';
import useConfigInject from '../config-provider/hooks/useConfigInject';
import { useConfigContextInject } from '../config-provider/context';
import warning from '../_util/warning';
import useStyle from './style';
export const emptyProps = () => ({
    prefixCls: String,
    /** @deprecated Please use `styles.image` instead */
    imageStyle: objectType(),
    image: anyType(),
    description: anyType(),
    /** Semantic structure className (antd ≥ 5.23). */
    classNames: objectType(),
    /** Semantic structure style (antd ≥ 5.23). */
    styles: objectType(),
});
const Empty = defineComponent({
    name: 'AEmpty',
    compatConfig: { MODE: 3 },
    inheritAttrs: false,
    props: emptyProps(),
    setup(props, { slots = {}, attrs }) {
        const { direction, prefixCls: prefixClsRef } = useConfigInject('empty', props);
        const { empty: ctxEmpty } = useConfigContextInject();
        const [wrapSSR, hashId] = useStyle(prefixClsRef);
        warning(props.imageStyle === undefined, 'Empty', '`imageStyle` is deprecated. Please use `styles.image` instead.');
        return () => {
            var _a, _b;
            const prefixCls = prefixClsRef.value;
            const emptyCfg = ctxEmpty === null || ctxEmpty === void 0 ? void 0 : ctxEmpty.value;
            const _c = Object.assign(Object.assign({}, props), attrs), { image: mergedImage = ((_a = slots.image) === null || _a === void 0 ? void 0 : _a.call(slots)) || h(DefaultEmptyImg), description = ((_b = slots.description) === null || _b === void 0 ? void 0 : _b.call(slots)) || undefined, imageStyle, classNames: emptyClassNames, styles: emptyStyles, class: className = '', style } = _c, restProps = __rest(_c, ["image", "description", "imageStyle", "classNames", "styles", "class", "style"]);
            const image = typeof mergedImage === 'function' ? mergedImage() : mergedImage;
            const isNormal = typeof image === 'object' && 'type' in image && image.type.PRESENTED_IMAGE_SIMPLE;
            return wrapSSR(<LocaleReceiver componentName="Empty" children={(locale) => {
                    const des = typeof description !== 'undefined' ? description : locale.description;
                    const alt = typeof des === 'string' ? des : 'empty';
                    let imageNode = null;
                    if (typeof image === 'string') {
                        imageNode = <img alt={alt} src={image}/>;
                    }
                    else {
                        imageNode = image;
                    }
                    return (<div class={classNames(prefixCls, className, hashId.value, emptyCfg === null || emptyCfg === void 0 ? void 0 : emptyCfg.className, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.root, {
                            [`${prefixCls}-normal`]: isNormal,
                            [`${prefixCls}-rtl`]: direction.value === 'rtl',
                        })} style={Object.assign(Object.assign(Object.assign({}, emptyCfg === null || emptyCfg === void 0 ? void 0 : emptyCfg.style), emptyStyles === null || emptyStyles === void 0 ? void 0 : emptyStyles.root), style)} {...restProps}>
                <div class={classNames(`${prefixCls}-image`, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.image)} style={Object.assign(Object.assign({}, imageStyle), emptyStyles === null || emptyStyles === void 0 ? void 0 : emptyStyles.image)}>
                  {imageNode}
                </div>
                {des && (<p class={classNames(`${prefixCls}-description`, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.description)} style={emptyStyles === null || emptyStyles === void 0 ? void 0 : emptyStyles.description}>
                    {des}
                  </p>)}
                {slots.default && (<div class={classNames(`${prefixCls}-footer`, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.footer)} style={emptyStyles === null || emptyStyles === void 0 ? void 0 : emptyStyles.footer}>
                    {filterEmpty(slots.default())}
                  </div>)}
              </div>);
                }}/>);
        };
    },
});
Empty.PRESENTED_IMAGE_DEFAULT = () => h(DefaultEmptyImg);
Empty.PRESENTED_IMAGE_SIMPLE = () => h(SimpleEmptyImg);
export default withInstall(Empty);
